<template>
	<section class="small-12 propertyMap">
		<div class="small-12" ref="propertyMap" id="propertyMap" style="height:100%"></div>
	</section>
</template>

<script>

	// Import the map css
	import 'mapbox-gl/dist/mapbox-gl.css'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertyMap',

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({
			accessToken: process.env.VUE_APP_MAPBOX_KEY,
			mapContainer: 'propertyMap',
			style: 'mapbox://styles/nestd/ckdalozr21auv1il29veqzvrh',
			latitude: null,
			longitude: null,
			pitch: 0,
			zoom: 14,
			bearing: 0,
			propertyMap: null,
			marker_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/framework%2Fproperty-location-marker.png?alt=media&token=e03446d1-60cb-4fc8-a311-99cabdbf8517'
		}),

		/*
		**  Watch em'
		*/

		watch: {

			property: {

				immediate: true, // Load on created
				handler(property) {

					if (property) {

						

						// Render the map
						if (this.$refs.propertyMap) {

							this.renderMap();

						}

					}

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	this.renderMap();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			renderMap: function () {

				// Set the props
				this.latitude = this.property.relationships.places.geometry.location.lat;
				this.longitude = this.property.relationships.places.geometry.location.lng;

				// Set the access token
				MapboxGL.accessToken = this.accessToken;

				// Create the map
				this.propertyMap = new MapboxGL.Map({
				    container: this.mapContainer,
				    style: this.style,
				    center: [this.longitude, this.latitude],
				    zoom: this.zoom,
				    pitch: this.pitch,
				    bearing: this.bearing
				});

				// Disable the scroll zoom
				this.propertyMap.scrollZoom.disable();

				// Add the navigation control
				this.propertyMap.addControl(new MapboxGL.NavigationControl(), 'top-right');

				// Place property marker
				this.placeExistingMarkers();

			},

			placeExistingMarkers: function() {

				let lat = this.property.relationships.places.geometry.location.lat,
					lng = this.property.relationships.places.geometry.location.lng,
					existingMarker = document.createElement('div'),
					width = 25,
					height = 25;

				// Set the marker's attributes
		    	existingMarker.setAttribute('id', this.property.id);
		    	existingMarker.setAttribute('class', 'animated propertyPinMarker');

			    // Set the marker
				new MapboxGL.Marker(existingMarker).setLngLat([lng, lat]).addTo(this.propertyMap);

			},

		}

	}

</script>